import { render, staticRenderFns } from "./updateBatch.vue?vue&type=template&id=2850c998&scoped=true"
import script from "./updateBatch.vue?vue&type=script&lang=js"
export * from "./updateBatch.vue?vue&type=script&lang=js"
import style0 from "./updateBatch.vue?vue&type=style&index=0&id=2850c998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850c998",
  null
  
)

export default component.exports